export default __webpack_public_path__ + "static/media/image-(55).9d393c89.svg";